import { render } from "./ClassDisableManagement.vue?vue&type=template&id=1c563122&scoped=true"
import script from "./ClassDisableManagement.vue?vue&type=script&lang=js"
export * from "./ClassDisableManagement.vue?vue&type=script&lang=js"

import "./ClassDisableManagement.vue?vue&type=style&index=0&id=1c563122&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c563122"]])

export default __exports__